<template>
  <div
    class="form-group"
    :class="[classEditor, { 'has-error': errors.has(name), 'form-group-active': active }]"
  >
    <ckeditor
      :editor="editor"
      :config="config"
      :name="name"
      :value="value"
      @ready="onResize"
      @blur="onResize"
      @focus="onResize"
      @input="$emit('input', $event)"
    ></ckeditor>
    <error-message :message="errors.first(name)"></error-message>
  </div>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
require("@ckeditor/ckeditor5-build-classic/build/translations/pt-br.js");

export default {
  inject: ["$validator"],
  name: "ckeditor-classic",
  props: {
    size: {
      default: "350px",
      type: String
    },
    value: {
      default: "",
      type: String
    },
    name: {
      default: "",
      type: String
    },
    placeholder: String
  },
  data() {
    return {
      editor: ClassicEditor,
      config: {
        placeholder: this.placeholder || "Escreva seu texto aqui!",
        language: "pt-br",
        toolbar: ["bold", "italic", "|", "bulletedList", "numberedList"]
      },
      active: false,
      classEditor: ""
    };
  },
  methods: {
    onResize() {
      if (this.size == "183px") {
        this.classEditor = "resize-183";
      }
      if (this.size == "250px") {
        this.classEditor = "resize-250";
      }
      if (this.size == "350px") {
        this.classEditor = "resize-350";
      }
    }
  }
};
</script>

<style>
.resize-183 .ck-editor__editable {
  height: 183px !important;
}

.resize-250 .ck-editor__editable {
  height: 250px !important;
}

.resize-350 .ck-editor__editable {
  height: 350px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/CKEditorClassic.vue